<template>
  <div>
    <gs-modal
      v-model="visible"
      :title="isEdit?name+'-时间事件-列表':'新建'+'-时间事件-列表'"
      :before-close="beforeClose"
      :before-confirm="beforeConfirm"
      :has-form="true"
      class="group-alarm"
      width="40%"
      top="10%"
      @cancel="close"
      @close="close"
      @confirm="handleConfirm"
    >
      <div>
        <a class="gs-modal-close" style="left: 90%;top: 12px"  @click="dialogHelp = true">
          <i class="el-icon-question" style="font-size: 17px;color: #737373"></i>
        </a>
      </div>
      <div class="page-form">
        <gs-form
          label-width="100px"
          label-position="left"
          gap="small"
        >
          <gs-form-item
            label="名称"
            prop="name"
          >
            <gs-input
              ref="nameInput"
              v-model="name"
            />
          </gs-form-item>
          <gs-form-item
            label="描述"
            prop="description"
            class="form-item-description"
          >
            <gs-input
              v-model="description"
              type="text"
            />
          </gs-form-item>

          <gs-form-item
            label="下一个事件"
            prop="nextEvent"
          >
            {{ nextEvent }}
          </gs-form-item>

          <gs-form-item
            label="事件列表"
            prop="timeChart"
            class="form-item-timeChart"
            style="margin-bottom:0px"
          />
          <div class="form-item-timeEventList">
            <gs-table
              :data="eventObjects"
              :height="170"
              style="width: 100%"
              @row-dblclick="openDetail"
              @select="getSelection"
              @select-all ="getSelection"
            >
              <gs-table-column
                type="selection"
                fixed
              />
              <gs-table-column
                prop="name"
                label="名称"
              />
              <gs-table-column
                prop="type"
                label="类型"
              />
            </gs-table>
          </div>
          <div class="bottom-btn">
            <gs-button @click="add">增加</gs-button>
            <gs-button @click="openDetail">属性</gs-button>
            <gs-button @click="del">删除</gs-button>
          </div>
        </gs-form>
      </div>
    </gs-modal>
    <gs-modal
      v-model="visibleAdd"
      :before-close="beforeCloseAdd"
      class="timeChart-select"
      title="添加时间事件"
      @close="closeAdd"
      @confirm="handleConfirmAdd"
    >
      <div class="dataList">
        <gs-tree
          v-if="visibleAdd"
          ref="tree"
          :data="dataList"
          :props="props"
          :disable-node="true"
          :leaf-checkbox-only="true"
          :node-key="'id'"
          show-checkbox
        />
      </div>
    </gs-modal>
    <gs-modal
      title="帮助-时间事件-列表"
      v-model = "dialogHelp"
      class="my-test-class"
      width="40%"
      top="10%"
      :before-close="handleCloseHelp">
      <span class="tab">常规</span><br>
      <hr />
      <span class="tit">名称：</span><span class="txt">趋势日志对象的名称</span><br>
      <span class="tit">描述：</span><span class="txt">该对的详细描述</span><br>
      <span class="tit">事件列表：</span><span class="txt">可以添加多个时间事件对象</span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
      <span class="tit"></span><span class="txt"></span><br>
    <!--<el-button @click="dialogHelp = false">取 消</el-button>
    <el-button type="primary" @click="dialogHelp = false">确 定</el-button>-->
      </span>
    </gs-modal>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import service from '../../service/leftService.js'
export default {
  data () {
    return {
      dialogHelp:false,
      objectInfo: {},
      isEdit: false,
      activeName: 'timeEventList',
      props: {
        label: 'name',
        disabled: 'type:folder'
      },
      eventObjects: [],
      name: '',
      description: '',
      dataList: [],
      visibleAdd: false,
      selection: []
    }
  },
  computed: {
    ...mapState({
      nodeData: 'nodeTree',
      objectData: 'objectInfo',
      visible: 'timeEventListShow'
    }),
    nextEvent () {
      return ''
    }
  },
  watch: {
    visible () {
      if (this.visible) {
        this.activeName = 'timeEventList'
        this.objectInfo = this.objectData
        setTimeout(() => {
          this.$refs.nameInput.focus()
        }, 100)
        if (JSON.stringify(this.objectInfo) !== '{}' && this.objectInfo.type === 'timeEventList') {
          this.eventObjects = this.objectInfo.attribute ? this.objectInfo.attribute.eventObjects : []
          this.description = this.objectInfo.description ? this.objectInfo.description : ''
          this.name = this.objectInfo.name ? this.objectInfo.name : ''
          this.isEdit = true
        } else {
          this.description = ''
          this.name = ''
          this.eventObjects = []
          this.isEdit = false
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      close: 'TIME_EVENT_LIST_HIDE',
      timeEventObejctShow: 'TIME_EVENT_OBJECT_SHOW'
    }),
    handleConfirm () {
      let eventObjects = []
      if (this.eventObjects !== null && this.eventObjects.length > 0) {
        this.eventObjects.forEach(e => {
          eventObjects.push(e.id)
        })
      }
      if (this.objectInfo.id != null && this.objectInfo.type === 'timeEventList') {
        let param = {
          'id': this.objectInfo.id,
          'name': this.name,
          'type': this.objectInfo.type,
          'value': this.objectInfo.value,
          'parentId': this.objectInfo.parentId,
          'description': this.description,
          'attribute': {
            'eventObjects': eventObjects
          }
        }
        service.renamePoint(param).then(res => {
          this.$Message.success('修改成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      } else {
        let param = {
          'name': this.name,
          'type': 'timeEventList',
          'parentId': this.objectInfo.id,
          'description': this.description,
          'attribute': {
            'eventObjects': eventObjects
          }
        }
        service.newAddPoint(param).then(res => {
          this.$Message.success('添加成功')
          this.close()
        }).catch(err => {
          this.$Message.error(err.message)
        })
      }
    },
    beforeConfirm (e, done) {
      if (this.name === null || this.name === '') {
        this.$Message.warning('名称不能为空!')
        return
      }
      // done(false)可以阻止modal关闭
      done()
    },
    beforeClose (e, done) {
      // done(false)可以阻止modal关闭
      this.close()
    },
    add () {
      this.dataList = []
      let _this = this
      this.visibleAdd = true
      service.getTree('TimeEvent',this.nodeData.id).then(res => {
        if (res[0] !== null) {
          this.dataList = res
        }
        if (_this.eventObjects !== null) {
          setTimeout(() => {
            _this.eventObjects.forEach(res => {
              _this.$refs.tree.setChecked(res.id, true)
            })
          }, 0)
        }
      })
    },
    del () {
      let _this = this
      if (this.selection === null || this.selection.length === 0) {
        this.$Message.warning('请至少选择一项')
        return
      }
      this.selection.forEach((value, index, array) => {
        _this.eventObjects = _this.eventObjects.filter(e => {
          return e.id !== value.id
        })
      })
    },
    beforeCloseAdd (e, done) {
      this.visibleAdd = false
    },
    closeAdd () {
      this.visibleAdd = false
    },
    handleConfirmAdd () {
      let _this = this
      this.$refs.tree.getCheckedNodes(true).forEach(e => {
        _this.eventObjects.push(e.data)
      })
      _this.eventObjects = this.unique(_this.eventObjects, 'id')
      this.visibleAdd = false
    },
    openDetail (row, event) {
      if (event) {
        this.$store.state.objectInfo = row
      } else {
        if (this.selection.length !== 1) {
          this.$Message.warning('只能勾选一项')
          return
        }
        this.$store.state.objectInfo = this.selection[0]
      }
      this.timeEventObejctShow()
    },
    getSelection (selection, row) {
      this.selection = selection
    },
    unique (arr, name) {
      var hash = {}
      return arr.reduce(function (item, next) {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next)
        return item
      }, [])
    },
    handleCloseHelp(){
      this.dialogHelp = false
    }
  }
}
</script>
<style lang="scss" scoped>
  .group-alarm {
    .page-form {
      .title {
        color: #0073e8;
        margin-bottom: 12px;
      }
      .gs-form-item {
        margin-bottom: 12px;
      }
      .button {
        float: right;
      }
    }
  }
  .dataList {
    height: 300px;
      overflow: auto;
      margin-bottom: 12px;
      padding: 12px;
      border: solid 1px #d9d9d9;
      border-radius: 1px;
  }
  .form-item-timeEventList {
    height: 200px;
      overflow: auto;
      margin-bottom: 12px;
      padding: 12px;
      border: solid 1px #d9d9d9;
      border-radius: 1px;
  }
  .bottom-btn {
      text-align: center
    }

</style>



// WEBPACK FOOTER //
// src/components/timeEvent/timeEventList.vue